import { ApiCallState } from "../Utils";
import { IndirectCost } from "../IndirectCost/IndirectCost.type";
import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";

export type PettyCashRequisition = {
  id: number;
  no?: number;
  pcr_number: string;
  date: string;
  description: string;
  indirect_cost_id: number;
  indirect_cost?: IndirectCost;
  project_id: number;
  project?: Project;
  name_user_id: number;
  name_user?: User;
  current_balance?: number;
  requested_balance: number;
  user_id: number;
  petty_cash_requisition_views?: any[];
  petty_cash_requisition_checkeds?: any[];
  petty_cash_requisition_approveds?: any[];
  petty_cash_requisition_authorizeds?: any[];
  createdAt?: any;
  updatedAt?: any;
};

export type PettyCashRequisitionStateTypes = {
  fetchAll: ApiCallState<PettyCashRequisition[]>;
  fetchOne: ApiCallState<PettyCashRequisition | {}>;
};

export const PettyCashRequisitionActionTypes = {
  FETCH_ALL_PETTY_CASH_REQUISITION: "FETCH_ALL_PETTY_CASH_REQUISITION",
  FETCH_ALL_PETTY_CASH_REQUISITION_RESET: "FETCH_ALL_PETTY_CASH_REQUISITION_RESET",
  FETCH_ALL_PETTY_CASH_REQUISITION_FAILURE: "FETCH_ALL_PETTY_CASH_REQUISITION_FAILURE",
  FETCH_ALL_PETTY_CASH_REQUISITION_SUCCESS: "FETCH_ALL_PETTY_CASH_REQUISITION_SUCCESS",

  FETCH_ONE_PETTY_CASH_REQUISITION: "FETCH_ONE_PETTY_CASH_REQUISITION",
  FETCH_ONE_PETTY_CASH_REQUISITION_RESET: "FETCH_ONE_PETTY_CASH_REQUISITION_RESET",
  FETCH_ONE_PETTY_CASH_REQUISITION_FAILURE: "FETCH_ONE_PETTY_CASH_REQUISITION_FAILURE",
  FETCH_ONE_PETTY_CASH_REQUISITION_SUCCESS: "FETCH_ONE_PETTY_CASH_REQUISITION_SUCCESS",
};
